import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Tooltip, IconButton, InputBase, Typography } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseAdvertisingManage } from "./UseAdvertisingManage";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

export default function AdvertisingManage() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { getAdvertisingManageList, deleteAdvertisingManage } =
    UseAdvertisingManage();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("ShamsiEndDate");
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const [advertisingManageRes, setAdvertisingManageRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getAdvertisingManageList(
      myPc,
      search,
      (advs) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(advs.pageCondition.totalPage);
          return;
        }
        setAdvertisingManageRes(advs);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/advertisingmanage/addAdvertisingManage", {
      state: {
        myPc: myPc,
        search: search,
        items: advertisingManageRes.items,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "advertismentTitle",
      headerName: "عنوان تبلیغ",
      width: 180,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.advertismentTitle}
          </Typography>
        );
      },
    },
    {
      field: "shamsiStartDate",
      headerName: "تاریخ شروع",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "shamsiEndDate",
      headerName: "تاریخ پایان",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "contractID",
      headerName: "شماره قرارداد",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.contractID ? cellValues.row.contractID : ""}
          </Typography>
        );
      },
    },
    {
      field: "done",
      headerName: "اتمام",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.done ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 110,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Delete">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());

                  return navigate("/advertisingmanage/editAdvertisingManage", {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "تبلیغات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/advertisingmanage" }],
      }}
    >
      {advertisingManageRes ? (
        <DataGrid
          className="ltr-grid"
          disableVirtualization
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={advertisingManageRes.pageCondition.pageCount}
          rows={advertisingManageRes.items}
          paginationMode="server"
          page={advertisingManageRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={advertisingManageRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              isLtr: true,
              rowCount: advertisingManageRes.pageCondition.totalItemCount,
            },
          }}
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "&  .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "&  .MuiDataGrid-cell:focus-within ": {
              outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
            },
            "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
              {
                outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
              },
            "& .MuiDataGrid-cell:hover": {
              opacity: "80%",
              cursor: "pointer",
            },
            "& .MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !important",
            },
            "& .red": {
              backgroundColor: "#ff9c9c !important",
            },
          }}
          getRowClassName={(params) => {
            if (params.row.endDay == 0 && params.row.done == false) {
              return "red";
            }
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"تبلیغ"}
        callback={() => {
          setProgress(true);
          deleteAdvertisingManage(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
